var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconVk = function SvgIconVk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.187 1.687C.5 3.374.5 6.09.5 11.52v.96c0 5.43 0 8.146 1.687 9.833S6.59 24 12.02 24h.96c5.43 0 8.146 0 9.833-1.687S24.5 17.91 24.5 12.48v-.96c0-5.43 0-8.146-1.687-9.833S18.41 0 12.98 0h-.96C6.59 0 3.874 0 2.187 1.687M4.55 7.3c.13 6.24 3.25 9.99 8.72 9.99h.31v-3.57c2.01.2 3.53 1.67 4.14 3.57h2.84c-.78-2.84-2.83-4.41-4.11-5.01 1.28-.74 3.08-2.54 3.51-4.98h-2.58c-.56 1.98-2.22 3.78-3.8 3.95V7.3H11v6.92c-1.6-.4-3.62-2.34-3.71-6.92z",
    clipRule: "evenodd"
  })));
};
export default SvgIconVk;